
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ReceiptRow',
  props: {
    label: {
      type: String,
      required: true
    },
    value: {
      type: [String, Number],
      required: true
    },
    highlight: {
      type: Boolean,
      default: false
    }
  }
});
